<template>
	<div class="advert-manage-container">
		<!-- 数据卡片 -->
		<InfoCards :data="assetStats" />
		<!-- 搜索条件 -->
		<QueryCard @search="handleSearch" @reset="handleReset">
			<template slot="base">
				<el-col :span="6">
					<el-input v-model="query.resourceNo" placeholder="请输入资源编号" />
				</el-col>
				<el-col :span="6">
					<el-input v-model="query.resourceName" placeholder="请输入资源名称" />
				</el-col>
				<el-col :span="6">
					<el-select v-model="query.resourceType" placeholder="请选择资源类型" clearable style="width: 100%">
						<el-option
							v-for="(item, index) in $menu.getList('ResourceType')"
							:key="index"
							:label="item.name"
							:value="item.value" />
					</el-select>
				</el-col>
			</template>
			<template slot="more">
				<el-col :span="6">
					<el-select v-model="query.currentStatus" placeholder="请选择租控状态" clearable style="width: 100%">
						<el-option
							v-for="(item, index) in $menu.getList('RentalStatus')"
							:key="index"
							:label="item.name"
							:value="item.value" />
					</el-select>
				</el-col>
			</template>
		</QueryCard>

		<!-- 表格 -->
		<BaseTable
			:actions="{
				add: true,
				export: true,
				operation: true,
			}"
			:loading="loading"
			:exportLoading="exportLoading"
			:data="tableData"
			:columns="columns"
			:total="total"
			:pageNum="query.page"
			:pageSize="query.size"
			@page-change="pageChange"
			@size-change="sizeChange"
			@add="handleAdd"
			@export="handleExport">
			<template slot="toolbar">
				<el-button size="small" icon="el-icon-takeaway-box" @click="handleMerge">合并资源</el-button>
			</template>
			<template #resourceType="{ row }">
				<el-tag :type="ResourceType[row.resourceType] || 'default'" size="small">
					{{ $menu.getLabel('ResourceType', row.resourceType) }}
				</el-tag>
			</template>
			<template #rentPrice="{ row }">
				{{ `¥${row.rentPrice}/㎡/月` }}
			</template>
			<template #monthlyRent="{ row }">
				{{ row.monthlyRent ? `¥${row.monthlyRent}` : '--' }}
			</template>

			<template #currentStatus="{ row }">
				<el-tag :type="RentalStatus[row.currentStatus] || 'default'" size="small">
					{{ $menu.getLabel('RentalStatus', row.currentStatus) }}
				</el-tag>
			</template>

			<template #operation="{ row }">
				<el-button type="text" @click="handleShow(row)">查看</el-button>
				<el-button v-if="row.currentStatus == 'AVAILABLE'" type="text" @click="handleSign(row)">签约</el-button>
				<el-button v-if="row.currentStatus == 'AVAILABLE'" type="text" @click="handleSplit(row)">拆分</el-button>
			</template>
		</BaseTable>

		<ResourceManageDialog :dialogVisible.sync="dialogVisible" @updateSuccess="updateSuccess" />
		<ResourceManageDrawer :dialogVisible.sync="drawerVisible" :data="currentRow" />
		<ResourceManageSignDialog
			:dialogVisible.sync="dialogSignVisible"
			:data="currentRow"
			@updateSuccess="updateSuccess" />
		<ResourceManageSplitDialog
			:dialogVisible.sync="dialogSplitVisible"
			:data="currentRow"
			@updateSuccess="updateSuccess" />
		<ResourceMergeDialog :dialogVisible.sync="dialogMergeVisible" @updateSuccess="updateSuccess" />
	</div>
</template>

<script>
	import { getResourceByPage, getResourceStatistics, exportResourceList } from '@/api/asset/resourceApi.js';

	import ResourceManageDialog from '@/components/asset/resourceManageDialog';
	import ResourceManageDrawer from '@/components/asset/resourceManageDrawer';
	import ResourceManageSignDialog from '@/components/asset/resourceManageSignDialog';
	import ResourceManageSplitDialog from '@/components/asset/resourceManageSplitDialog';
	import ResourceMergeDialog from '@/components/asset/resourceMergeDialog';
	import { getCommunityId } from '@/utils/vc.js';
	import { ResourceType, RentalStatus } from '@/utils/meunType.js';
	export default {
		name: 'ResourceManage',
		components: {
			ResourceManageDialog,
			ResourceManageDrawer,
			ResourceManageSignDialog,
			ResourceManageSplitDialog,
			ResourceMergeDialog,
		},
		data() {
			return {
				RentalStatus,
				ResourceType,
				assetStats: [
					{ key: 'totalCount', label: '总资源数', value: 0, unit: '个', color: '#5B8FF9' },
					{ key: 'rentedCount', label: '已出租', value: 0, unit: '个', color: '#61DDAA' },
					{ key: 'rentalRate', label: '出租率', value: 0, unit: '%', color: '#FF9D4D' },
					{ key: 'vacantCount', label: '空置可租', value: 0, unit: '个', color: '#F6BD16' },
					{ key: 'reservedCount', label: '已预订', value: 0, unit: '个', color: '#7262fd' },
					{ key: 'expiringCount', label: '本月到期', value: 0, unit: '个', color: '#FF6E76' },
				],
				total: 0,
				query: {
					resourceNo: '',
					resourceName: '',
					resourceType: '',
					currentStatus: '',
					communityId: getCommunityId(),
					page: 1,
					size: 10,
				},
				tableData: [],
				columns: [
					{ prop: 'resourceNo', label: '资源编号' },
					{ prop: 'resourceName', label: '资源名称', width: 200 },
					{ prop: 'resourceType', label: '资源类型', width: 100, slot: 'resourceType' },
					{ prop: 'assetNo', label: '关联资产', width: 150 },
					{ prop: 'assetName', label: '资产名称', width: 150 },
					{ prop: 'area', label: '面积(㎡)', width: 100 },
					{ prop: 'rentPrice', label: '租金单价', width: 120, slot: 'rentPrice' },
					{ prop: 'monthlyRent', label: '月租金', width: 120, slot: 'monthlyRent' },
					{ prop: 'currentStatus', label: '租控状态', width: 100, slot: 'currentStatus' },
					{ prop: 'tenantName', label: '租客名称', width: 150 },
					{ prop: 'expiryDate', label: '到期日期', width: 120 },
				],
				communityId: getCommunityId(),
				loading: false,
				exportLoading: false,
				currentRow: {},
				dialogVisible: false,
				dialogSignVisible: false,
				drawerVisible: false,
				dialogSplitVisible: false,
				dialogMergeVisible: false,
			};
		},
		created() {
			this.fetchGetResourceStatistics();
			this.getList();
		},
		methods: {
			async fetchGetResourceStatistics() {
				try {
					const res = await getResourceStatistics({
						communityId: this.communityId,
						ResourceType: '',
					});
					this.assetStats = this.assetStats.map(item => ({
						...item,
						value: res[item.key] || 0,
					}));
				} catch (err) {
					console.log(err);
				}
			},
			async getList() {
				try {
					this.loading = true;
					const res = await getResourceByPage(this.query);
					this.total = Number(res.total);
					this.tableData = res.records || [];
				} catch (err) {
					console.log(err);
				} finally {
					this.loading = false;
				}
			},
			updateSuccess() {
				this.query.page = 1;
				this.query.size = 10;
				this.getList();
			},
			pageChange(page) {
				this.query.page = page;
				this.getList();
			},
			sizeChange(size) {
				this.query.size = size;
				this.getList();
			},
			handleSearch() {
        this.query.page = 1;
				this.getList();
			},
			splitSuccess() {
				this.fetchGetResourceStatistics();
				this.getList();
			},
			handleReset() {
				this.query = {
					resourceNo: '',
					resourceName: '',
					resourceType: '',
					currentStatus: '',
					communityId: getCommunityId(),
					page: 1,
					size: 10,
				};
				this.getList();
			},
			handleAdd() {
				this.dialogVisible = true;
			},
			handleExport() {
				if (this.exportLoading) return;
				const params = {
					page: this.query.page,
					size: this.query.size,
					communityId: this.communityId,
					currentStatus: this.query.currentStatus,
					resourceName: this.query.resourceName,
					resourceNo: this.query.resourceNo,
					resourceType: this.query.resourceType,
				};
				this.exportLoading = true;
				exportResourceList(params)
					.then(response => {
						const blob = new Blob([response.data]);
						let fileName = '资源列表.xlsx';
						const disposition = response.headers && response.headers['content-disposition'];
						if (disposition) {
							const utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i);
							const normalMatch = disposition.match(/filename="?([^";]+)"?/i);
							const raw = utfMatch ? utfMatch[1] : (normalMatch ? normalMatch[1] : '');
							if (raw) {
								fileName = decodeURIComponent(raw);
							}
						}
						const url = window.URL.createObjectURL(blob);
						const link = document.createElement('a');
						link.style.display = 'none';
						link.href = url;
						link.setAttribute('download', fileName);
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						window.URL.revokeObjectURL(url);
						this.$message.success('导出成功');
					})
					.catch(err => {
						console.log(err);
						this.$message.error('导出失败');
					})
					.finally(() => {
						this.exportLoading = false;
					});
			},
			handleMerge() {
				this.dialogMergeVisible = true;
			},
			handleSign(row) {
				this.currentRow = row;
				this.dialogSignVisible = true;
			},
			handleSplit(row) {
				this.currentRow = row;
				this.dialogSplitVisible = true;
			},
			handleShow(row) {
				this.currentRow = row;
				this.drawerVisible = true;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.advert-manage-container {
		padding: 20px;
		text-align: left;
	}
</style>
